// toolkit/index.ts
// Legacy API Client (kept for backward compatibility - will be deprecated)

export * from './components/api-client/APIPersistor.helper';

// App Root
export * from './components/app-root/ApplicationRoot.component';

// Database
export * from './components/indexed-database/Generic.db';

// Logger
export * from './components/logger';
export * from './components/validator.util';
export * from './components/format.util';
export { default } from './components/logger';

// Gainsight PX event tracking
export * from './components/gainsight';

// Window Utils
export * from './components/window-utils/Window.util';
export * from './components/window-utils/LogErrors.util';
export * from './components/window-utils/Persistor.util';

// ============================================
// NEW DECORATOR-BASED API CLIENT SYSTEM
// ============================================
// Core HTTP Client
export {
  PublicHttpClient,
  HttpError,
  isAuthTimeExceededError,
} from './components/api-client/PublicHttpClient';
export type { HttpClientConfig } from './components/api-client/PublicHttpClient';

// Decorators
export * from './components/api-client/APIResource.decorator';
export * from './components/api-client/APIMethod.decorator';

// Helper Functions
export * from './components/api-client/ApiClient';

// Client Registry
export * from './components/api-client/ClientRegistry';

// React Hooks
export * from './components/api-client/Fetch';
export * from './components/api-client/Commit';
export * from './components/hooks/toast/Toast.hook';
export * from './components/hooks/polling/usePolling.hook';

// Alert
export * from './components/hooks/alert/AlertService';

// IAM Models
export * from './models/IAM.model';

export * from './components/react-table-cell-render/RenderReactCell';

export * from './components/error-handler/ErrorHandler.util';
